<wiz-vgroup padding="10px" width="100%" height="100%" class="section-container">
  <wiz-hgroup width="100%">
    <wiz-label [wizLabel]="'$.connect.title.$'" width="100%" class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="hide()">close</wiz-icon>
  </wiz-hgroup>

  <wiz-hgroup padding="5px" width="100%" height="100%">
    <wiz-ag-grid #agGrid width="100%" height="100%" 
    [gridOptions]="gridOptions"
    [frameworkComponents]="renderers"
    [wizRowSelection]="'multiple'"
    [columnDefs]="columns"
    [wizDatasource]="connectDS" class="ag-theme-alpine"></wiz-ag-grid>
  </wiz-hgroup>

  <wiz-hgroup width="100%" height="100%" horizontalAlign="end" verticalAlign="end">
    <wiz-button wizLabel="$.common.validate.$" (wizClick)="onSave()"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
